import React, { useEffect, useState } from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'

import Footer from '../Footer/Main'
import AddNewAdminForm from '../AddNewAdminForm/Main'
import { getStrapiData } from '../../api.controller'

function Main() {
  const [data, setData] = useState();
  useEffect(() => {
    getStrapiData("add-career-listing-page").then(response => {
      console.log(response);
      setData(response.data);
    });
  }, []);
  return (
    <div>
      <div className="page-wrapper">
        <Header />
        <Breadcrumb data={data} subtitle="Home" title="Add New Admin" />
        <AddNewAdminForm />
        <Footer />
      </div>
    </div>
  )
}

export default Main